import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'OrderSnapshot',
    column_type: 'id',
    label_key_path: 'orderSnapshot.id',
  },
  created_at: {
    model_name: 'OrderSnapshot',
    column_type: 'datetime',
    label_key_path: 'orderSnapshot.createdAt',
  },
  updated_at: {
    model_name: 'OrderSnapshot',
    column_type: 'datetime',
    label_key_path: 'orderSnapshot.updatedAt',
  },
  order: {
    model_name: 'OrderSnapshot',
    column_type: 'belongs_to',
    label_key_path: 'orderSnapshot.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  order_id: {
    model_name: 'OrderSnapshot',
    column_type: 'belongs_to',
    label_key_path: 'orderSnapshot.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  readed: {
    model_name: 'OrderSnapshot',
    column_type: 'boolean',
    label_key_path: 'orderSnapshot.readed',
  },
  changes_product_image: {
    model_name: 'OrderSnapshot',
    column_type: 'string',
    label_key_path: 'orderSnapshot.changesProductImage',
  },
  changes_content: {
    model_name: 'OrderSnapshot',
    column_type: 'string',
    label_key_path: 'orderSnapshot.changesContent',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
